<template>
  <div class="title_and_more">
    <div class="title">
      <slot name="title">
        <span>{{ title }}</span>
      </slot>
    </div>
    <div class="value">
      <span @click="handleClickRight">
      <slot name="value">
        <span>{{ value }}</span>
      </slot>
        </span>
    </div>

    <span @click="handleClickRight">
      <slot name="rightIcon">
        <van-icon class="right_icon" :name="rightIcon"/>
      </slot>
    </span>
  </div>
</template>

<script>

export default {
  name: 'TitleAndMore',
  components: {},
  props: {
    title: {
      type: String,
      default: '标题'
    },
    value: {
      type: String,
      default: '更多'
    },
    rightIcon: {
      type: String,
      default: 'arrow'
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    handleClickRight() {
      this.$emit("afterMore")
    }
  }
}
</script>

<style lang="scss" scoped>
.title_and_more {
  width: 100%;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  flex-grow: 0;
  flex-shrink: 0;

  .title {
    color: #323233;
    flex-grow: 1;
    text-align: left;
  }

  .value {
    text-align: right;
    flex-grow: 0;
    flex-shrink: 0;
    cursor: pointer;
    margin-left: 10px;
  }

  .right_icon {
    margin-left: 4px;
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
  }
}
</style>
